interface PricingCardProps {
  name: string;
  price: string;
  description: string;
  features: string[];
  buttonText: string;
  highlighted?: boolean;
  isLoading?: boolean;
  onSelect?: () => void;
}

export default function PricingCard({
  name,
  price,
  description,
  features,
  buttonText,
  highlighted = false,
  isLoading = false,
  onSelect,
}: PricingCardProps) {

  const numericPrice = price.split('/')[0];
  const priceSuffix = price.includes('/') ? `/${price.split('/')[1]}` : '';

  return (
    <div
      className={`rounded-2xl p-8 bg-white flex flex-col h-full ${highlighted
        ? "shadow-2xl ring-2 ring-brand-green"
        : "shadow-lg ring-1 ring-gray-200"
        }`}
    >
      <div className="flex-grow">
        <h3 className="text-lg font-semibold text-gray-900">{name}</h3>
        <p className="mt-4 text-sm leading-6 text-gray-600">{description}</p>
        <p className="mt-6">
          <span className="text-4xl font-bold tracking-tight text-gray-900">
            {numericPrice}
          </span>
          <span className="text-sm font-semibold text-gray-600">{priceSuffix}</span>
        </p>
        <ul className="mt-8 space-y-3 text-gray-600">
          {features.map((feature, index) => (
            <li key={index} className="flex gap-x-3 text-sm">
              <svg
                className="h-6 w-5 flex-none text-brand-green"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
                  clipRule="evenodd"
                />
              </svg>
              {feature}
            </li>
          ))}
        </ul>
      </div>
      <button
        onClick={onSelect}
        disabled={isLoading}
        className={`
          w-full mt-8 py-3 px-4 rounded-lg font-medium transition-colors
          ${isLoading
            ? 'bg-gray-400 cursor-not-allowed'
            : highlighted
              ? 'bg-secondary hover:bg-secondary-dark text-white'
              : 'bg-gray-100 hover:bg-gray-200 text-gray-800'
          }
        `}
      >
        {buttonText}
      </button>
    </div>
  );
}
